import { useEffect, useState } from "react";
import Select from 'react-select';
import SearchOff from "../components/SearchOff";
import SearchGrafikPlanned from "../components/SearchGrafikPlanned";
import { getplanedPodiys } from "../Axios/searchoff";

const DispetcherPage = () => {

    const typeOptions = [
        {value: 1, label: 'Поточні відключення'},
        {value: 0, label: 'Планові відключення'},
    ]

    const [selectedType, setSelectedType] = useState({value: 1, label: 'Поточні відключення'});

    useEffect(()=>{
        window.scrollTo(0,0);
    }, [])

    return (
        <section className="power-off">
            <div className="container">
            <h2 className='power-off__title'>
                Універсальний пошук вимкнень
            </h2>
            <div className="power-off__disp">
                <div className="content" data-aos="fade-up">
                <div className="power-off__disp-type-inner">
                    <label htmlFor="type">Тип пошуку*</label>
                    <Select 
                        cacheOptions
                        id={'type'}
                        placeholder={"Оберіть тип пошуку"} 
                        onChange={setSelectedType} 
                        options={typeOptions}
                        defaultValue={{value: '1', label: 'Поточні відключення'}}
                        loadingMessage={() => 'Завантаження...'}
                    />
                </div>
                {selectedType.value === 1 && <SearchOff search = 'disp' />}
                {selectedType.value === 0 && <SearchGrafikPlanned getPodiys = {getplanedPodiys} search = 'disp'/>}
                </div>
            </div>
            </div>
        </section> 
    )
}

export default DispetcherPage